import axios from 'axios';
import { apiClientEndUserService, apiClientService } from './ApiClients';
import {
  authenticatedRequest,
  preAuthApiClientService,
  preAuthApiEndUserService,
  unauthenticatedRequest,
} from './AuthService';
import { environment } from 'src/environments/environment';

const forgotPasswordRequest = async (form_data: object) => {
  try {
    const response = await axios.post<any>(
      environment.REACT_APP_CLIENT_BASE_URL +
        '/api/client/password/request/create',
      form_data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response;
  } catch (error) {
    console.error('API Error ', error);
    return error;
  }
};

const forgotPasswordVerify = async (form_data: object) => {
  try {
    const response = await axios.post<any>(
      environment.REACT_APP_CLIENT_BASE_URL + '/api/client/password/verify',
      form_data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  } catch (error) {
    console.error('API Error ', error);
    return error;
  }
};

const resetPassword = async (form_data: object) => {
  try {
    const response = await authenticatedRequest(
      apiClientService,
      '/api/client/reset/password',
      'post',
      form_data
    );
    return response;
  } catch (error) {
    console.error('API Error ', error);
    return error;
  }
};

const requestToLoginAsPartner = async (client_account_id: number) => {
  const form_data = {
    client_account_id: client_account_id,
  };
  try {
    const response = await authenticatedRequest(
      apiClientService,
      '/api/client/token/request',
      'post',
      form_data
    );
    return response;
  } catch (error) {
    console.error('API Error ', error);
    return error;
  }
};

const createStripePaymentIntent = async () => {
  try {
    const response = await unauthenticatedRequest(
      preAuthApiClientService,
      '/api/create-payment-intent',
      'post'
    );
    return response;
  } catch (error) {
    console.error('API Error ', error);
    throw error;
  }
};

const verifyCard = async (paymentIntentId: string) => {
  try {
    const response = await unauthenticatedRequest(
      preAuthApiClientService,
      '/api/verify-card',
      'post',
      { paymentIntentId } // ✅ FIXED
    );
    return response;
  } catch (error) {
    console.error('API Error ', error);
    throw error;
  }
};

const saveCopy = async (email: string, redemptionId?: string) => {
  try {
    const payload = {
      email: email,
      redemption_id: redemptionId, // Pass redemption_id if needed
    };

    const response = await preAuthApiClientService.post(
      '/api/priceless-redemptions',
      payload
    );
    return response;
  } catch (error) {
    console.error('API Error ', error);
    throw error;
  }
};

export {
  forgotPasswordRequest,
  forgotPasswordVerify,
  requestToLoginAsPartner,
  resetPassword,
  createStripePaymentIntent,
  verifyCard,
  saveCopy
};
